import httpManager from "../../../../shared/utils/httpManager";

/**
 * Obtener contacto.
 *
 * @param {Number} id
 * @return {Promise<Object>} Contacto
 */
export async function fetchPaymentsClient(id) {
  const url = `/contacts/clients/${id}/payments/`;
  const response = await httpManager.get(url);

  return response.data;
}
